import { gql } from "@apollo/client";

/**
 * Get Fund Holdings Query
 * 
 * Fetches holdings for a specific fund with available fields.
 * Removed deprecated fields: quantityOfStock, oneMonthQtyChange, 
 * oneYearHighestPt, oneYearLowestPt, newEntry
 */
const GET_FUND_HOLDINGS = gql`
  query GetFundHoldings(
    $mutualFundId: Int!
    $holdingMonth: String!
    $holdingYear: String!
  ) {
    getFundHoldings(
      mutualFundId: $mutualFundId
      holdingMonth: $holdingMonth
      holdingYear: $holdingYear
    ) {
      id
      mutualFundId
      stockName
      stockSector
      holdingMonth
      holdingYear
      valueInMn
      percentageOfTotalHoldings
      oneMonthChangeInPtHoldings
    }
  }
`;

export default GET_FUND_HOLDINGS;
